import React from "react";


const CustomTooltip = ({ classNames, text}) => {
    return (
        <span className={`customTooltip ${classNames}`}>
            {text}
        </span>
    )
}

export default CustomTooltip;